
import MediaListPage from '.';

export default {
    mediaListPage: {
        path: '/media',
        title: 'Media',
        // permissions: [apiConfig.tag.getList.permissionCode],
        auth: true,
        component: MediaListPage,
    },
};
